import Swiper from 'swiper';

window.addEventListener('load', function () {
  const carousels = document.querySelectorAll('.anchors-banner__btns-carousel');
  const anchorsBanner = document.querySelector('.anchors-banner-block');
  const anchorBtns = document.querySelectorAll('.anchors-banner__btns .link');
  let stop;
  const docBody =
    document.documentElement || document.body.parentNode || document.body;
  const hasOffset = window.pageYOffset !== undefined;
  let scrollTop = hasOffset ? window.pageYOffset : docBody.scrollTop;

  if (anchorsBanner) {
    this.document.body.classList.add('has-anchors-banner');
    stop = anchorsBanner.offsetTop - 85;

    if (scrollTop >= stop) {
      anchorsBanner.classList.add('is-sticky');
    } else {
      anchorsBanner.classList.remove('is-sticky');
    }

    window.addEventListener('scroll', function () {
      scrollTop = hasOffset ? window.pageYOffset : docBody.scrollTop;

      if (scrollTop >= stop) {
        anchorsBanner.classList.add('is-sticky');
      } else {
        anchorsBanner.classList.remove('is-sticky');
      }
    });

    anchorBtns.forEach(function (anchorBtn) {
      anchorBtn.addEventListener('click', function (e) {
        if (anchorBtn.getAttribute('href').startsWith('#')) {
          e.preventDefault();
          let offset =
            document.querySelector('.navbar-secondary').clientHeight + 106;

          if (document.getElementById('wpadminbar')) {
            offset =
              offset + document.getElementById('wpadminbar').clientHeight;
          }

          const section = document.querySelector(
            anchorBtn.getAttribute('href')
          );
          if (section) {
            const sectionStyle = window.getComputedStyle(section);
            if (sectionStyle.marginTop) {
              offset = offset + parseInt(sectionStyle.marginTop);
            }
            if (!anchorsBanner.classList.contains('is-sticky')) {
              offset = offset + anchorsBanner.clientHeight;
            }
            const y =
              window.scrollY + section.getBoundingClientRect().top - offset;
            window.scroll({
              top: y,
              behavior: 'smooth',
            });
          }
        }
      });
    });
  }

  // carousels init
  if (0 < carousels.length) {
    carousels.forEach(function (carousel) {
      new Swiper(carousel, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        breakpoints: {
          960: {
            spaceBetween: 32,
          },
        },
      });
    });
  }
});
